import { Mail } from 'lucide-react';
import React from 'react'

const UserAgreementContent = () => {
  return (
    <div style={{ maxHeight: "400px", overflowY: "auto", padding: "10px" }}>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        <strong>Company: InteliQuant AI Private Limited</strong> (“Provider”,
        “we”, “our”, “us”)
        <br />
        <strong>Platform: XynexAI Intelligence Platform</strong> (“Platform”,
        “XynexAI”, “Service”)
      </p>
      <p>
        This Global User License Agreement (“Agreement”) governs your access to
        and use of the XynexAI Platform worldwide. By accessing or using
        XynexAI, you (“User”, “Customer”, “you”) agree to be bound by this
        Agreement
      </p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>1. GRANT OF LICENSE </strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        Provider grants User a{" "}
        <b>
          worldwide, limited, revocable, non-exclusive, non-transferable,
          non-sublicensable license
        </b>{" "}
        to :
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Access and use XynexAI</li>
        <li>Upload and process business data</li>
        <li>Allow authorized employees/contractors to use the Platform</li>
        <li>Use API integrations (if enabled)</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        This license is limited to:
      </p>

      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Internal business operations</li>
        <li>Decision-support and analytics</li>
        <li>Workflow automation</li>
        <li>Responsible AI-based insights</li>
      </ul>
      <p>No ownership rights are granted.</p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 2. Ownership & Intellectual Property Rights</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        All intellectual property in XynexAI, including:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Source code, algorithms, models</li>
        <li>LLM orchestration layers</li>
        <li>Analytics engines and automation workflows</li>
        <li>UI/UX elements</li>
        <li>Documentation and APIs</li>
        <li>Prompts, configurations, embeddings</li>
      </ul>
      <p>
        is the exclusive property of{" "}
        <strong> InteliQuant AI Private Limited.</strong>
      </p>
      <p>
        User receives <strong> no implied licenses and cannot:</strong>
      </p>

      <ul style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}>
        <li>Copy, extract, or replicate the platform</li>
        <li>Build competing AI systems</li>
        <li>Train models using XynexAI outputs</li>
      </ul>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>3. Permitted Use</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>User may:</p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Upload lawful business data</li>
        <li>Generate internal-use insights, predictions, and analytics</li>
        <li>Produce internal reports and dashboards</li>
        <li>Access APIs and integrations</li>
        <li>Use GenAI features responsibly</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        User must comply with:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Applicable local and global laws</li>
        <li>Global privacy regulations</li>
        <li>AI governance and safety guidelines</li>
        <li>Export control rules</li>
      </ul>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>4. Prohibited Activities</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        User shall <b>NOT:</b>:
      </p>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>4.1 Technical Misuse</strong>
      </h5>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Reverse engineer, decompile, attempt to extract model weights</li>
        <li>Attack or interfere with system security</li>
        <li>Introduce malware or harmful code</li>
        <li>Circumvent authentication methods</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>4.2 Commercial Misuse</strong>
      </h5>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Resell, sublicense, rent, or offer XynexAI as a service</li>
        <li>Build competing or derivative AI platforms</li>
        <li>Train external LLMs using XynexAI outputs</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>4.3 Illegal, Harmful, or Unethical Use</strong>
      </h5>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Upload unlawful or infringing data</li>
        <li>Use XynexAI for harassment, fraud, deception</li>
        <li>Generate unlabelled deepfakes or harmful synthetic media</li>
        <li>
          Use for biological, chemical, medical, or weapons-related applications
        </li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>4.4 EU AI Act - Prohibited Uses</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        XynexAI may NOT be used for:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Social scoring</li>
        <li>Biometric categorization</li>
        <li>Emotion recognition in workplace/school</li>
        <li>Behavioral manipulation</li>
        <li>Surveillance prohibited by law</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>4.5 High-Risk AI Use Requires Written Approval</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>Including:</p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Credit scoring</li>
        <li>Employment screening</li>
        <li>Education assessments</li>
        <li>BHealthcare triage</li>
        <li>Public-sector decision-making</li>
      </ul>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>5. Confidentiality (Mutual)</strong>
      </h4>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>5.1 Provider Obligations</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>We agree to:</p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Treat User data as confidential</li>
        <li>Use data only to operate XynexAI</li>
        <li>Limit access to authorized personnel</li>
        <li>Not disclose data unless legally required</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>5.2 User Obligations</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        User agrees to maintain confidentiality regarding:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Platform functionality, APIs, and design</li>
        <li>Proprietary workflows & system metrics</li>
        <li>Any non-public documentation</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        Both parties follow:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>
          <strong>ISO 27001 information security controls</strong>
        </li>
        <li>
          <strong>Zero Trust architecture</strong>
        </li>
      </ul>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>6. Data Handling & Global Compliance </strong>
      </h4>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>6.1 Data Ownership</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        All data uploaded remains <b>User-owned.</b>
      </p>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>6.2 Processing Commitments</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        We process data only to:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Provide platform functionality</li>
        <li>Generate outputs requested by User</li>
        <li>Improve security, reliability, and performance</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>We DO NOT:</p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Sell personal data</li>
        <li>Share data with advertisers</li>
        <li>Use customer data to train third-party models</li>
      </ul>

      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>6.3 Global Data Protection Compliance</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        XynexAI complies with:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>
          <b>EU GDPR / UK-GDPR</b>
        </li>
        <li>
          <b>US CCPA/CPRA</b>
        </li>
        <li>
          <b>UAE PDPL</b>
        </li>
        <li>
          <b>Saudi PDPL</b>
        </li>
        <li>
          <b>India DPDP Act</b>
        </li>
        <li>
          <b>Brazil LGPD</b>
        </li>
        <li>
          <b>Singapore PDPA</b>
        </li>
        <li>
          <b>Australia Privacy Act</b>
        </li>
        <li>
          <b>Canada PIPEDA</b>
        </li>
        <li>
          <b>South Africa POPIA</b>
        </li>
      </ul>

      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>6.4 International Transfers</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        Cross-border transfers use:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>EU Standard Contractual Clauses (SCCs)</li>
        <li>UK International Data Transfer Addendum</li>
        <li>India DPDP transfer rules</li>
        <li>PDPL-compliant safeguard mechanisms</li>
      </ul>

      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>6.5 Saudi PDPL Data Localization</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        Where legally required, personal data of Saudi users will be stored{" "}
        <strong>within the Kingdom of Saudi Arabia.</strong>
      </p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>
          7. GenAI Processing (OpenAI Enterprise & Other LLM Providers)
        </strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        If GenAI features are enabled:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Only minimal required data is sent to LLM providers</li>
        <li>No data is retained or used for training</li>
        <li>All traffic is encrypted</li>
        <li>Synthetic content may require labeling under law</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        User acknowledges:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>AI outputs may be approximate</li>
        <li>Human verification is required</li>
        <li>Certain AI outputs may be restricted/blocked</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        This complies with:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>EU AI Act transparency & oversight</li>
        <li>FTC AI guidelines</li>
        <li>OECD/NIST AI standards</li>
      </ul>
      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>8. Termination & Suspension</strong>
      </h4>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>8.1 Provider may suspend access if:</strong>
      </h5>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>The User violates the Agreement</li>
        <li>User uploads illegal or harmful content</li>
        <li>Payment failures occur (if subscription-based)</li>
        <li>User threatens platform or data security</li>
        <li>Required by law, regulator, or court order</li>
      </ul>
      <h5 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>8.2 Termination Effects</strong>
      </h5>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        Upon termination:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>All access is revoked immediately</li>
        <li>
          Data is deleted within <b>30 days</b>
        </li>
        <li>Some logs may be retained if legally required</li>
      </ul>
      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 9. Disclaimer of Warranties</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        XynexAI is provided <strong>“AS IS”</strong>, without warranties of:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Accuracy of AI outputs</li>
        <li>Uninterrupted service</li>
        <li>Fitness for medical, legal, financial, or safety-critical use</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        User must validate AI outputs.
      </p>
      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong>10. Limitation of Liability</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        To the maximum extent permitted:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>
          Provider’s total liability is limited to{" "}
          <strong>fees paid in the last 3 months</strong>
        </li>
        <li>Provider is NOT liable for:</li>
        <li>Lost profits</li>
        <li>Data loss</li>
        <li>Business interruption</li>
        <li>Indirect or incidental damages</li>
        <li>AI errors or inaccuracies</li>
        <li>Third-party failures</li>
      </ul>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 11. Export Control & Sanctions Compliance</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        User MUST comply with:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>
          <b>US OFAC sanctions & SDN list</b>
        </li>
        <li>
          <b>EU Dual-Use Regulations</b>
        </li>
        <li>
          <b>UK OFSI sanctions</b>
        </li>
        <li>
          <b>Indian Export Control laws</b>
        </li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        User may NOT use XynexAI in or for:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Iran</li>
        <li>North Korea</li>
        <li>Syria</li>
        <li>Crimea region</li>
        <li>Or other embargoed regions</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        We reserve the right to block access from sanctioned territories.
      </p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 12. Compliance with Global Law</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        This Agreement complies with:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Indian Contract Act</li>
        <li>GDPR, UK-GDPR</li>
        <li>CCPA/CPRA</li>
        <li>EU AI Act</li>
        <li>PDPL (UAE, Saudi)</li>
        <li>DPDP Act 2023</li>
        <li>OECD & NIST AI Frameworks</li>
        <li>International IP treaties (TRIPS, Berne Convention)</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        Governing law is <strong>India</strong>, with jurisdiction in{" "}
        <strong>Jodhpur, Rajasthan</strong>, unless superseded by mandatory
        regional laws.
      </p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 13. Modifications to Agreement</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        Provider may update these Terms due to:
      </p>
      <ul
        style={{ marginLeft: "20px", marginBottom: "16px", lineHeight: "1.6", listStyleType: "disc", }}
      >
        <li>Regulatory changes</li>
        <li>AI safety requirements</li>
        <li>Platform enhancements</li>
        <li>Security improvements</li>
      </ul>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        Continued use = acceptance.
      </p>

      <h4 style={{ marginTop: "20px", marginBottom: "12px" }}>
        <strong> 14. Contact Information</strong>
      </h4>
      <p style={{ marginBottom: "16px", lineHeight: "1.6" }}>
        For legal, compliance, or support inquiries:
      </p>
      <a
        href="mailto:info@inteliquantai.com"
        style={{
          marginBottom: "16px",
          lineHeight: "1.6",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
        }}
      >
        <Mail />
        <span>info@inteliquantai.com</span>
      </a>
    </div>
  );
}

export default UserAgreementContent
